jQuery(document).ready(function () {
    var resizeTimer = null,
        nav = jQuery('.sidebar-navigation'),
        navNext = nav.next('.wp-block-columns').children().last();

    function resize() {
        var winWidth = window.innerWidth;
        if (resizeTimer) {
            window.clearTimeout(resizeTimer);
        }
        resizeTimer = window.setTimeout(function () {
            var marginSize = 30 - nav.height();
            if (winWidth >= 782) {
                nav.css('margin-bottom', marginSize);
                navNext.css('margin-top', -marginSize);
            } else {
                nav.css('margin-bottom', 32);
                navNext.css('margin-top', 32);
            }
        }, 300);
    }
    jQuery(window).resize(resize);
    resize();
});
